export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  // Only declare a JSON body when one is sent; a DELETE with a JSON
  // content-type but no body is rejected by the server as malformed.
  if (init?.body != null && !headers.has('content-type')) headers.set('content-type', 'application/json');
  const response = await fetch(path, { ...init, headers });
  const raw = await response.text();
  const data = raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
  if (!response.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : `${response.status} ${response.statusText}`);
  }
  return data as T;
}

export const get = <T>(path: string) => api<T>(path);
export const post = <T>(path: string, body: unknown = {}) => api<T>(path, { method: 'POST', body: JSON.stringify(body) });
export const del = <T>(path: string, init?: RequestInit) => api<T>(path, { ...init, method: 'DELETE' });
